__turbopack_context__.v({
  "inner_wrap": "SectionTitle-module-scss-module__rCpUYa__inner_wrap",
  "large": "SectionTitle-module-scss-module__rCpUYa__large",
  "medium": "SectionTitle-module-scss-module__rCpUYa__medium",
  "small": "SectionTitle-module-scss-module__rCpUYa__small",
  "subtext": "SectionTitle-module-scss-module__rCpUYa__subtext",
  "title": "SectionTitle-module-scss-module__rCpUYa__title",
  "wrap": "SectionTitle-module-scss-module__rCpUYa__wrap",
});
